import React from 'react'

import { alpha, styled } from '@mui/material/styles'
import Button, { ButtonProps } from '@mui/material/Button'

import colors from '@/assets/scss/_themes-vars.module.scss'

export const StyledButton = styled(Button)({
  background: colors.indigo800,
  minWidth: 'unset',
  padding: '6px 8px',
  '&:hover': {
    background: alpha(colors.indigo800, 0.75)
  }
})

export const TopbarButton = React.forwardRef(function TopbarButton(props: ButtonProps, ref: React.Ref<HTMLButtonElement>) {
  return <StyledButton {...props} ref={ref} />
})

export default TopbarButton